import EventLiveUpdateMapper from './event-live-update-mapper';
import LiveModel from '../../agent/live/live-model';

const EventLiveUpdateModel = {
    mapper: EventLiveUpdateMapper,

    categoryId: {
        fieldName: 'c',
        type: String,
    },

    eventId: {
        fieldName: 'e',
        type: String,
    },

    leagueId: {
        fieldName: 'g',
        type: String,
    },

    live: {
        fieldName: 'l',
        type: Boolean,
    },

    liveStatistics: {
        fieldName: 'a',
        model: LiveModel,
        type: Object,
    },

    scheduleDate: {
        fieldName: 'd',
        type: Number,
    },

    sportId: {
        fieldName: 's',
        type: String,
    },

    type: {
        fieldName: 't',
        type: String,
    },
};

export default EventLiveUpdateModel;
